import Swal from 'sweetalert2'

function Success(config) {
  const title = config?.title ?? 'Success'
  const text = config?.text ?? ''
  const defaultConfig = {
    title: title,
    html: text,
    icon: 'success'
  }

  if (config?.autoDismiss) {
    defaultConfig.timer = config.timer ?? 1500
    defaultConfig.showConfirmButton = true
    defaultConfig.timerProgressBar = false
  }

  return Swal.fire(defaultConfig)
}

export { Success }
